module.exports = __webpack_public_path__ + "65b4f7572ed92083c32a0774208f328c.MP3";